import { useCallback, useContext } from 'react';
import MaiaTranslationContext from './MaiaTranslationContext';

function interpolate(template, values) {
  if (!values || typeof template !== 'string') {
    return template;
  }
  return template.replace(/\{(\w+)\}/g, (_, key) =>
    Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : `{${key}}`
  );
}

/**
 * @param {string} id Translation key (dot notation, e.g. maia.nav.dashboard).
 * @param {string} fallback Shown when the key is missing in the segment file (like notification translate.getText).
 * @param {Record<string, string | number>} [values] Optional `{ name }` for `Hello {name}`.
 */
export function useMaiaT() {
  const { messages } = useContext(MaiaTranslationContext);

  return useCallback(
    (id, fallback, values) => {
      const raw = messages[id];
      const resolved = raw !== undefined && raw !== '' ? raw : fallback;
      return interpolate(resolved, values);
    },
    [messages]
  );
}
